import ErrorText from '../ErrorText'

import styles from './style.module.scss'

export default function TextArea({ value, onChangeText, error, errorMessage, containerStyle }) {
  return (
    <div style={{ display: 'flex', flex: 1, flexDirection: 'column', ...containerStyle }}>
      <textarea
        value={value}
        className={styles.form_text_area}
        onChange={e => {
          onChangeText(e.target.value)
        }}
      />

      {error && <ErrorText errorMessage={errorMessage} />}
    </div>
  )
}
